var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "divBox",
    },
    [
      _c(
        "el-card",
        {
          staticClass: "box-card",
          attrs: { shadow: "never", bordered: false },
        },
        [
          _c(
            "el-form",
            {
              ref: "formData",
              staticClass: "form-boder-padding",
              attrs: {
                rules: _vm.rules,
                model: _vm.formData,
                "label-width": "130px",
              },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "新用户赠送：", prop: "newUserCashAmount" } },
                [
                  _c("el-input-number", {
                    attrs: {
                      min: 0,
                      step: 0.01,
                      "controls-position": "right",
                      "step-strictly": "",
                      placeholder: "请输入金额",
                    },
                    model: {
                      value: _vm.formData.newUserCashAmount,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "newUserCashAmount", $$v)
                      },
                      expression: "formData.newUserCashAmount",
                    },
                  }),
                  _vm._v("元 "),
                  _c("div", { staticClass: "from-tips" }, [
                    _vm._v("每个周期活动开始时第一个红包"),
                  ]),
                ],
                1
              ),
              _vm._l(_vm.formData.walletRangeConfigs, function (item, index) {
                return _c(
                  "div",
                  { key: index },
                  [
                    _c("h2", { staticClass: "form_label mb10" }, [
                      _vm._v(_vm._s(item.title)),
                    ]),
                    _c(
                      "el-form-item",
                      { attrs: { label: "每日佣金类型：" } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: { placeholder: "请选择佣金类型" },
                            model: {
                              value: item.commissionType,
                              callback: function ($$v) {
                                _vm.$set(item, "commissionType", $$v)
                              },
                              expression: "item.commissionType",
                            },
                          },
                          _vm._l(_vm.typeOptions, function (itm) {
                            return _c("el-option", {
                              key: itm.value,
                              attrs: { label: itm.label, value: itm.value },
                            })
                          }),
                          1
                        ),
                        _c("div", { staticClass: "from-tips" }, [
                          _vm._v("用户每日参与活动后，所赠送的红包类型"),
                        ]),
                      ],
                      1
                    ),
                    _c("el-form-item", { attrs: { label: "限定总金额：" } }, [
                      item.commissionType === 1
                        ? _c(
                            "div",
                            { staticClass: "acea-row mb10" },
                            [
                              _c("el-input-number", {
                                attrs: {
                                  min: 0,
                                  step: 0.01,
                                  "controls-position": "right",
                                  "step-strictly": "",
                                  placeholder: "请输入金额",
                                },
                                model: {
                                  value: item.cashAmountLimit,
                                  callback: function ($$v) {
                                    _vm.$set(item, "cashAmountLimit", $$v)
                                  },
                                  expression: "item.cashAmountLimit",
                                },
                              }),
                              _c("div", [_vm._v("元")]),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c("div", { staticClass: "from-tips" }, [
                        _vm._v("用户每日参与活动后，所赠送的佣金额度"),
                      ]),
                    ]),
                  ],
                  1
                )
              }),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "hasPermi",
                          rawName: "v-hasPermi",
                          value: ["platform:commission:levelConfig:update"],
                          expression:
                            "['platform:commission:levelConfig:update']",
                        },
                      ],
                      attrs: { type: "primary", loading: _vm.loading },
                      on: {
                        click: function ($event) {
                          return _vm.handleSubmit("formData")
                        },
                      },
                    },
                    [_vm._v("保存")]
                  ),
                ],
                1
              ),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }